//export const API_URL = "http://localhost:8080"; //Staging
// export const Hosting_URL = "http://localhost:3000"; //Staging

export const Hosting_URL = "https://notify-service-ontario.firebaseapp.com"; //Prod
export const API_URL = "https://notify-odslab.herokuapp.com"; //Prod
